import { Grid, Typography, TextField, Button, Link } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sendGeneralRequest } from '../../../../../features/generalRequest';
import { makeStyles } from '@mui/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import colors from '../../../../colors';
import { texts } from '../../../../general/texts';
import AddDriversTpl from './AddDriversTpl';

export const Tpl = (props) => {
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()
    const [addDrivers, setAddDrivers] = useState(false)
    const [transID, setTransID] = useState('')
    const [client, setClient] = useState('')
    const [vin, setVin] = useState('')
    const isSmallScreen = useMediaQuery('(max-width:600px)')

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        token: props.globalDataSliceState.token,
        plate: '',
        vinNr: ''
    })
    const dispatch = useDispatch()

    const handleTextFieldChange = (prop) => (e) => {
        setState({
            ...state,
            [prop]: prop === "plate" ? e.target.value.toUpperCase() : e.target.value
        })
    }

    const startTpl = () => {
        dispatch(sendGeneralRequest({ request: { token: state.token, plate: state.plate, vin: state.vinNr }, baseUrlKey: 'services', endpoint: 'SigurimeMotorrike/StartTpl' })).then(response => {
            if (response.payload.response.success) {
                setTransID(response.payload.response.transID)
                setClient(response.payload.response.Client)
                setVin(response.payload.response.Vin)
                setAddDrivers(true)
            }
        })
    }

    React.useEffect(() => {
        if (myContractsSliceState.shouldFillFields) {
            setState({
                ...state,
                plate: props.selectedContractInfo.contract,
                vinNr: props.selectedContractInfo.description
            })
            dispatch(setShouldFillFields(false))
        }
    }, [myContractsSliceState.shouldFillFields])

    const isButtonDisabled = () => {
        return (!state.plate)
    }

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%',
            height: 'auto'
        },
        utilityName: {
            color: colors.orange,
            fontSize: '1.5rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '70px',
            height: '70px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold'
        },
        buttonGrid: {
            marginTop: 270,
            paddingBottom: 5
        },
        image: {
            width: '70%',
        },
        textField: {
            width: '100%'
        }
    })

    const classes = useStyles()

    return (
        <>
            {addDrivers ? (
                <AddDriversTpl data={props} transID={transID} plate={state.plate} client={client} vin={vin} />
            ) : (
                <Grid container item className={classes.mainGrid} rowSpacing={2}>
                    <Grid container item md={2} xs={2} mt={2} >
                        <Link component={'button'} onClick={() => { navigate(-1) }}>
                            <ArrowBackIosNewIcon color='warning' />
                        </Link>
                    </Grid>
                    <Grid container item md={12} xs={12}>
                        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} >
                            <img src={props.utilityInfo?.Images?.filter(image => image.color === 1 && image.size === 1)[0]?.imagePath} className={classes.image} />
                        </Grid>
                        <Typography className={classes.utilityName} >{props.utilityInfo?.PublicName}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12} >
                        <Typography className={classes.fieldTitle}>{texts["prompt-fill-fields"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12}  >
                        <TextField onChange={handleTextFieldChange('plate')} value={state.plate} color='warning' size='small' label={texts["placeholder-utility-plate"]} className={classes.textField} inputProps={{ style: { textTransform: 'uppercase' } }} />
                    </Grid>
                    <Grid container item md={12} xs={12}>
                        <TextField onChange={handleTextFieldChange('vinNr')} value={state.vinNr} color='warning' size='small' label={"Vendosni shasinë e mjetit"} className={classes.textField} inputProps={{ style: { textTransform: 'uppercase' } }}/>
                    </Grid>
                    <Grid item md={12} xs={12} className={classes.buttonGrid} >
                        <Button disabled={isButtonDisabled()} onClick={startTpl} className={classes.button}>
                            {texts["button-continue"]}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </>
    )
}

export default Tpl;
